import { createSlice } from '@reduxjs/toolkit';
import { defaultLanguage } from 'i18n/config';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    language: defaultLanguage,
    drawerOpen: false,
    loading: true,
    loadingRecommendations: false,
    needsContactInfo: false,
    needsOnboarding: false,
    preferredName: '',
    unrecoverableError: false,
    chatFeedback: {
      action: undefined,
      item: undefined
    },
  },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setDrawerOpen: (state, action) => {
      state.drawerOpen = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingRecommendations: (state, action) => {
      state.loadingRecommendations = action.payload;
    },
    setNeedsContactInfo: (state, action) => {
      state.needsContactInfo = action.payload;
    },
    setNeedsOnboarding: (state, action) => {
      state.needsOnboarding = action.payload;
    },
    setPreferredName: (state, action) => {
      state.preferredName = action.payload;
    },
    setUnrecoverableError: (state, action) => {
      state.unrecoverableError = action.payload;
    },
    setChatFeedback: (state, action) => {
      state.chatFeedback = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setLanguage,
  setDrawerOpen,
  setLoading,
  setLoadingRecommendations,
  setNeedsContactInfo,
  setNeedsOnboarding,
  setPreferredName,
  setUnrecoverableError,
  setChatFeedback,
} = appSlice.actions;

export default appSlice.reducer